import jquery from "jquery";
import $ from "jquery";
import "slick-carousel";
var Masonry = require("masonry-layout");

$(".slider-wrapper").on("init", function (event, slick) {
  $(".count").text(parseInt(slick.currentSlide + 1) + "/" + slick.slideCount);
});

$(".slider-wrapper").on("afterChange", function (event, slick, currentSlide) {
  $(".count").text(parseInt(slick.currentSlide + 1) + "/" + slick.slideCount);
});
$(".slider-wrapper").slick({
  arrows: false,
  dots: true,
  dotsClass: "slick-dots col-12 col-md-3",
  draggable: false,
  fade: true,
  speed: 400,
  autoplay: true,
  autoplaySpeed: 7000,
  adaptiveHeight: false,
});

const hamburgerTag = document.querySelector("div.toggle");
const menuTag = document.querySelector(".main-nav");

hamburgerTag.addEventListener("click", function (event) {
  hamburgerTag.classList.toggle("is-active");
  menuTag.classList.toggle("is-active");
});

$(".toggle-tabs li").click(function () {
  $(this)
    .addClass("active-tab")
    .parents("ul.toggle-tabs")
    .find("li")
    .not($(this))
    .removeClass("active-tab");
  var currentTabIndex = $(this).index();
  $(".content-box:eq(" + currentTabIndex + ")")
    .addClass("active-content-box")
    .parents(".tabbed-content-wrap")
    .find(".content-box")
    .not($(".content-box:eq(" + currentTabIndex + ")"))
    .removeClass("active-content-box");
});

$(".list .filter li a").click(function (e) {
  showinRange($(this));
});

$(".list .filter li a").click(function (e) {
  event.stopPropagation();
});

function showinRange(btn) {
  var slug = btn.attr("data-range");

  $(".list .list-item").removeClass("active");

  $(".list .list-item").each(function (e) {
    var categories = $(this).attr("data-range");
    if (categories) {
      if (categories.indexOf(slug) > -1) $(this).toggleClass("active");
    }
  });

  $(".list .filter li a").removeClass("active");
  btn.addClass("active");
}

$(".portfolio .filter li a").click(function (e) {
  showinRange2($(this));
});

$(".portfolio .filter li a").click(function (e) {
  event.stopPropagation();
});

function showinRange2(btn) {
  var slug = btn.attr("data-category");

  $(".portfolio_items .portfolio_item").removeClass("actives");

  $(".portfolio_items .portfolio_item").each(function (e) {
    var categories = $(this).attr("data-category");
    if (categories) {
      if (categories.indexOf(slug) > -1) $(this).toggleClass("actives");
    }
  });

  $(".portfolio .filter li a").removeClass("actives");
  btn.addClass("actives");
}

$("#nav-tab .nav-item").click(function (e) {
  $(".portfolio_items .portfolio_item").removeClass("actives");
  $(".portfolio_items .portfolio_item").addClass("actives");
});

function numberFormat(_number, _sep = ",") {
  _number = typeof _number != "undefined" && _number > 0 ? _number : "";
  _number = _number
    .replace(
      new RegExp(
        "^(\\d{" + (_number.length % 3 ? _number.length % 3 : 0) + "})(\\d{3})",
        "g"
      ),
      "$1 $2"
    )
    .replace(/(\d{3})+?/gi, "$1 ")
    .trim();
  if (typeof _sep != "undefined" && _sep != " ") {
    _number = _number.replace(/\s/g, _sep);
  }
  return _number;
}

document.addEventListener("DOMContentLoaded", function () {
  var counterValueElements = $(".counter-value");

  var evaluate = function (e) {
    counterValueElements.each(function () {
      var $this = $(this);

      if ($this.hasClass("counter-value--initialized")) {
        return;
      }

      var oTop = $this.offset().top - window.innerHeight;

      if ($(window).scrollTop() < oTop) {
        return;
      }

      $this.addClass("counter-value--initialized");

      var countTo = $this.attr("data-count");

      $({
        countNum: $this.text(),
      }).animate(
        {
          countNum: countTo,
        },
        {
          duration: 2400,
          easing: "swing",
          step: function () {
            $this.text(Math.floor(this.countNum).toLocaleString("en"));
          },
          complete: function () {
            $this.text(this.countNum.toLocaleString("en"));
          },
        }
      );
    });
  };

  $(window).on("scroll", evaluate);
  evaluate();
});

var map = document.querySelector("#map");
if (map == null) {
  /*donoting*/
} else {
  var msnry = new Masonry("#map .companies", {
    itemSelector: ".col-4",
    columnWidth: ".grid-sizer",
    percentPosition: true,
  });
}
